import { useEffect } from 'react';
import { CustomFont } from 'src/api/fontApi';
import { useCustomFonts } from 'src/hooks/useCustomFonts';

const STYLE_ELEMENT_ID = 'npt-custom-fonts';

const escapeForCssString = (value: string) =>
   value
      .replace(/\\/g, '\\\\')
      .replace(/'/g, "\\'")
      .replace(/"/g, '\\"')
      .replace(/\r/g, '\\D ')
      .replace(/\n/g, '\\A ')
      .replace(/\f/g, '\\C ')
      .replace(/\u2028/g, '\\2028 ')
      .replace(/\u2029/g, '\\2029 ');

const escapeForCssUrl = (value: string) => encodeURI(decodeURI(value)).replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29');

const buildFontFaceCss = (fonts: CustomFont[]) =>
   fonts
      .filter(f => f.s3Path && f.fontFamily)
      .flatMap(f => {
         const weight = Number.isFinite(f.weight) ? f.weight : 400;
         const style = f.style === 'italic' ? 'italic' : 'normal';
         const src = `url('${escapeForCssUrl(f.s3Path)}') format('${escapeForCssString(f.fileFormat)}')`;

         const semantic = `@font-face {
            font-family: '${escapeForCssString(f.fontFamily)}';
            src: ${src};
            font-weight: ${weight};
            font-style: ${style};
            font-display: swap;
         }`;

         if (!f.displayName || f.displayName === f.fontFamily) return [semantic];

         const exact = `@font-face {
            font-family: '${escapeForCssString(f.displayName)}';
            src: ${src};
            font-weight: ${weight};
            font-style: ${style};
            font-display: swap;
         }`;

         return [semantic, exact];
      })
      .join('\n');

const CustomFontsLoader = () => {
   const { data: fonts } = useCustomFonts();

   useEffect(() => {
      if (!fonts) return;

      let styleEl = document.getElementById(STYLE_ELEMENT_ID) as HTMLStyleElement | null;
      if (!styleEl) {
         styleEl = document.createElement('style');
         styleEl.id = STYLE_ELEMENT_ID;
         document.head.appendChild(styleEl);
      }

      const css = buildFontFaceCss(fonts);
      if (styleEl.textContent !== css) {
         styleEl.textContent = css;
      }
   }, [fonts]);

   return null;
};

export default CustomFontsLoader;
